import { useNavigate } from "react-router-dom"
import { pageRoutes } from "../dictionary"
import { HomepageReactGAHandlers } from "../ReactGAHandlers"

const faqComponent = (title, body, index) => {

  const { handleHomepageClick } = HomepageReactGAHandlers()

  return <div
    className="accordion dca-home-faq-accordion"
    id={`accordionFAQ${index}`}>
    <div className="accordion-item">
      <h2
        className="accordion-header">
        <button
          onClick={(e) => {
            if (!e.currentTarget.classList.contains('collapsed')) {
              handleHomepageClick(`FAQ Expand ${index + 1}`);
            }
          }}
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#faq${index}`}
          aria-expanded="false"
          aria-controls={`faq${index}`}>

          <span className='dca-home-faq-title'>{title}</span>
        </button>
      </h2>

      <div
        id={`faq${index}`}
        className={`accordion-collapse collapse`}
        data-bs-parent={`#faq${index}`}>
        <div className="accordion-body dca-home-faq-body">
          {body}

        </div>
      </div>
    </div>
  </div>
}

export const FAQ = () => {

  let navigate = useNavigate()

  let faqOne = {
    title: 'Who should use NextFour?',
    body: `NextFour is designed to support students considering the most selective US colleges (i.e. the top-100 ranked schools) which typically require the strongest applications. We encourage families to start planning for college well before senior year, and our service is designed to help students and parents throughout the high school years.`,
  }

  let faqTwo = {
    title: 'How is NextFour different?',
    body: `NextFour uniquely utilizes data and AI to help families confidently make key decisions across their college planning journey - such as which colleges to pursue, identifying intended majors, selecting extracurricular activities, determining a standardized testing strategy, etc. Our experience indicates that this data-driven approach is far more effective than only relying on anecdotal advice.`,
  }

  let faqThree = {
    title: `Is NextFour free to use?`,
    body: `Yes, it's very easy to get started as most aspects of our service are free, which aligns with our mission to help democratize access to information and provide an inclusive resource.`,
  }

  let faqs = [faqOne, faqTwo, faqThree]

  const separator = <div className="separator" style={{ width: '95%', margin: '0 auto' }}></div>

  return <div className="dca-home-faq-wrapper">
    {faqComponent(faqOne.title, faqOne.body, faqs.indexOf(faqOne))}

    {separator}

    {faqComponent(faqTwo.title, faqTwo.body, faqs.indexOf(faqTwo))}

    {separator}

    {faqComponent(faqThree.title, faqThree.body, faqs.indexOf(faqThree))}

    <span
      onClick={() => navigate(pageRoutes.faq)}
      className="dca-home-faq-more-link">More FAQ</span>
  </div>
}